// SPDX-License-Identifier: AGPL-3.0-or-later
export type OAuth2Scope = 'identify' | 'email' | 'guilds' | 'connections' | 'bot' | 'admin';
export const OAuth2Scopes: ReadonlyArray<OAuth2Scope> = [
	'identify',
	'email',
	'guilds',
	'connections',
	'bot',
	'admin',
] as const;
